import angular from 'angular';
import mycrmTable from './mycrmTable';

export default angular
  .module('components.mycrmTable', [])
  .component('mycrmTable', mycrmTable).name;
